import { Injectable } from '@angular/core';
import {
  tvdData,
  TvdMetricDisplayData
} from '../types/tvd-types';

@Injectable({
  providedIn: 'root'
})
export class TvdMetricDisplayDataBuilder {

  build(data: tvdData | undefined): TvdMetricDisplayData {

    const isMonetaryContributionModified = this.isModified(data?.modifiedMonetaryContribution);
    const isValueContributionModified = this.isModified(data?.modifiedValueContribution);

    return {
      currentMonetaryContribution: isMonetaryContributionModified
        ? data?.modifiedMonetaryContribution || '0'
        : data?.monetaryContribution || '0',

      defaultMonetaryContribution: isMonetaryContributionModified
        ? data?.monetaryContribution || '0'
        : undefined,

      currentValueContribution: isValueContributionModified
        ? data?.modifiedValueContribution || '0'
        : data?.valueContribution || '0',

      defaultValueContribution: isValueContributionModified
        ? data?.valueContribution || '0'
        : undefined,

      isMonetaryContributionModified,
      isValueContributionModified
    };
  }

  private isModified(value: string | undefined): boolean {
    return Number(
      (value || '0').replace(/,/g, '')
    ) > 0;
  }
}